import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { FormContext } from './FormContext'
import useForceUpdate from '../hooks/useForceUpdate'

const FormContextWrapper = ({ children }) => {
  const { clear, setClear } = React.useContext(FormContext)
  const forceUpdate = useForceUpdate()

  useEffect(() => {
    if (clear) {
      forceUpdate()
      setClear(false)
    }
  }, [forceUpdate, clear, setClear])

  return clear ? (<div />) : children
}

FormContextWrapper.propTypes = {
  children: PropTypes.node.isRequired
}

export default FormContextWrapper
